import React, { useState } from "react";

import { Container, Row, Col, Card, Form, Button, Modal, Accordion, Dropdown } from "react-bootstrap";
import { withRouter } from "react-router";
import '../_scss/Header.scss';
import Sidebar from "./Sidebar.js";
import $ from 'jquery';
import { propTypes } from "react-bootstrap/esm/Image";
const iconPath = process.env.PUBLIC_URL + '/icons/';

export default function Header(props) {
    let [show, setShow] = useState(false);
    let [menuClass, setMenuClass] = useState('');
    const showHideMenu = (element) => {
     
       
       setShow(!show)
    }



    return (
        <div className="header-container">
            <div className="row">
                <div className="col-6">
                    <div className="logoText">
                    <img className="app-logo" src={`${iconPath}logo.png`} onClick={()=> props.history.push('/dashboard')}></img>
                    </div>
                </div>
                <div className="col-6">
                    <div className="menu-items">
                        <div className="menu-content">
                            {/* <div className="user-profile">

                                <img src={`${iconPath}profile.png`}></img>
                            </div>
                            <div className="notification">
                                <img src={`${iconPath}notification.png`}></img>
                            </div> */}

                            <div className="menu-container"  onMouseOver={(e) => {
                                        $('#menuIcon').attr("src",`${iconPath}menu_blue.svg`);
                                        }}
                                        onMouseOut={(e) => {
                                            $("#menuIcon").attr("src",`${iconPath}menu.png`);
                                        }}>
                                
                                <img src={`${iconPath}menu.png`} id="menuIcon" onClick={() => showHideMenu()}></img>
                            </div>
                        </div>
                    </div>
                </div>

           
        </div>
                                        {show &&
                <div id="sideMenubar" className={menuClass} >  <Sidebar auth={props.auth} showSideBar={show} onUpdate={(result)=> setShow(result)}/>
                </div>
                                        }
      </div>
      
      
     


    )
}
